"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressBarTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const Size_1 = require("../../DesignSystem/tokens/global/Size");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const progressBarHeight = new DesignToken_1.default({
    name: 'progressBar-height',
    parent: Size_1.sizeTokens.sizeXXS
});
const progressBarBackgroundColor = new DesignToken_1.default({
    name: 'progressBar-backgroundColor',
    parent: Global_1.globalTokens.oldTokens.colorAccent
});
exports.progressBarTokens = {
    progressBarHeight,
    progressBarBackgroundColor
};
//# sourceMappingURL=ProgressBar.js.map